import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Home from "./Home";
import Login from "./Login";
import Ticket from "./CreateTicket";
import Dashboard from "./Dashboard";
import Questions from "./CreateQuestions";
import PendingTickets from "./PendingTickets";
import ITServicesRequest  from "./ItServicesRequest";
import ArticlesPage from "./ArticlesPage";
import Article from "./CreateArticle";
import ChatSection from "./ChatSection";
import Categories from "./CreateModule";
import AssignedTickets from "./AssignedTickets";
import RespondedTickets from "./RespondedTickets";
import RequestUserFeedBacks from "./RequestUserfeedbacks";
import Userfeedbacks from "./Userfeedbacks";
import Surveys from "./Surveys";
import ProtectedLayout from "./ProtectedLayout";
import ArticleDetailPage from "./ArticleDetailPage";
import FAQDetailPage from "./FAQDetailPage";
import SurveyFormView from "./SurveyFormView";
import SurveyResponsesView from "./SurveyResponsesView";
import DataLoader from "./components/DataLoader";
import RequestAppointment from "./RequestAppointment";
import IPPISSettingsPage from "./IPPISSettingsPage";
import SurveryInterviewQuestionForm from "./SurveyInterviewQuestionsForm";
import WelcomePage from "./recruiting-company-welcome-page";
import RecruitingPortal from "./reporting-form";
import NavigationPage from "./navigation-page";
import MappingGrobalPositions from "./MappingGrobalPositions";
import RBMExceptions from "./RBMExceptions";
const setupGlobalSessionHandlers = () => {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const url =
      typeof args[0] === "string" ? args[0] : args[0].url;

  if (
  response.status === 401 &&
  !url.includes("/api/auth/login") &&
  !url.includes("/api/auth/login-hiring-company")
) {
      localStorage.removeItem("isLoggedIn");
      window.location.href = "/Login?reason=session-expired";
      return Promise.reject(new Error("Unauthorized"));
    }

    return response;
  };

  const handleStorageChange = (e) => {
    if (e.key === "isLoggedIn" && !e.newValue) {
      window.location.href = "/Login?reason=session-ended";
    }
  };

  window.addEventListener("storage", handleStorageChange);
  return () => window.removeEventListener("storage", handleStorageChange);
};

function App() {
  useEffect(() => {
    const cleanup = setupGlobalSessionHandlers();
    return cleanup;
  }, []);

  return (
    <div className="app-container">
      <DataLoader>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/CreateTicket" element={<Ticket />} />
          <Route path="/articles/:articleId" element={<ArticleDetailPage />} />
          <Route path="/faqs/:faqId" element={<FAQDetailPage />} />
          <Route path="/SurveyFormView/:surveyId" element={<SurveyFormView />} />
          <Route path="/SurveyResponsesView/:surveyId" element={<SurveyResponsesView />} />
          <Route path="/ArticlesPage" element={<ArticlesPage />} />
          <Route path="/SurveryInterviewQuestionForm" element={<SurveryInterviewQuestionForm />} />
          <Route path="/recruiting-company-welcome-page" element={<WelcomePage />} />
          <Route path="/reporting-form" element={<RecruitingPortal />} />
            <Route path="/navigation-page" element={<NavigationPage />} />

          {/* Protected routes using ProtectedLayout */}
          <Route element={<ProtectedLayout />}>
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/CreateQuestions" element={<Questions />} />
            <Route path="/CreateArticle" element={<Article />} />
            <Route path="/PendingTickets" element={<PendingTickets />} />
            <Route path="/AssignedTickets" element={<AssignedTickets />} />
            <Route path="/ChatSection" element={<ChatSection />} />
            <Route path="/CreateModule" element={<Categories />} />
            <Route path="/RespondedTickets" element={<RespondedTickets />} />
            <Route path="/Userfeedbacks" element={<Userfeedbacks />} />
            <Route path="/RequestUserfeedbacks" element={<RequestUserFeedBacks />} />
            <Route path="/Surveys" element={<Surveys />} />
            <Route path="/RequestAppointment" element={<RequestAppointment />} />
            <Route path="/IPPISSettingsPage" element={<IPPISSettingsPage />} />
            <Route path="/MappingGrobalPositions" element={<MappingGrobalPositions />} />
            <Route path="/RBMExceptions" element={<RBMExceptions />} />
            <Route path="/ITServicesRequest" element={<ITServicesRequest />} />
          </Route>
        </Routes>
      </DataLoader>
    </div>
  );
}

export default App;